import React from 'react';
// @ts-ignore
import logo from '../../images/kindur-logo.svg';
import LinkButton  from '../../elements/LinkButton';
import styled from '@emotion/styled';
import colors from '../../styles/colors';


const Link = styled(LinkButton)`
  background-color: transparent;
  border-color: transparent;
  color: ${colors.MediumGray};
  font-family: 'DM Sans', sans-serif;
  font-size: 1.125rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 2.1em;
  padding: 0;
  text-decoration: none;
`;

const NavbarLinks = ({ closeSidebar, track, trackComponentName, setSidebarVisible }) => (
  <>
    <Link
      to={`/`}
      title={`Kindur Homepage`}
      onClick={() => {
        track(`Logo`, trackComponentName);
        closeSidebar();
      }}
    >
      <img src={logo} alt={`Kindur logo`} />
    </Link>
    <Link
      to={'/about/'}
      onClick={() => {
        track(`AboutUs`, trackComponentName);
        setSidebarVisible(false);
      }}
    >
      About Us
    </Link>
    <Link
      title={'Kindur Login'}
      href={'https://app.kindur.com/login'}
      onClick={() => {
        track(`Login`, trackComponentName);
      }}
    >
      Kindur Login
    </Link>
  </>
);

export default NavbarLinks;
